<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingData">
        <div slot="body">
          <bita-form ref="form">
            <div slot="body">
              <div style="margin-bottom: 20px">
                <bita-form ref="form">
                  <div slot="body">
                    <div class="row">
                      <bita-input
                        type="text"
                        name="national_code"
                        label="کدملی راننده"
                        rules="irani"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.national_code"
                        @change="(e) => searchForDrivers(e)"
                        subtitle="جستجو فقط با کد‌ملی کامل و صحیح"
                      />
                      <bita-input
                        type="text"
                        name="tracking_code"
                        label="کد پیگیری"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        @change="(e) => findTrackingCode(e)"
                        v-model.lazy="filters.tracking_code"
                        subtitle=" کد پیگیری را بدون پیشوند وارد نمایید.(تنها اعداد مثلا: ۱۲۳−۱۲۳۴۵۶)"
                      />
                      <bita-input
                        type="text"
                        name="number_plate"
                        label="شماره پلاک خودرو"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model="filters.number_plate"
                        @change="findNumberPlate"
                      />
                      <bita-select
                        ref="customerDropDown"
                        name="customers"
                        label="مشتری"
                        rules
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="customers"
                        data-text-field="full_name"
                        data-value-field="id"
                        @change="loadData"
                        v-model="filters.customer_id"
                      />
                      <bita-select
                        name="state"
                        label="استان مقصد"
                        ref="destinationstateDropDown"
                        rules
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="state"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="filters.destination_province_id"
                        @change="(e) => this.getCityDestination(e)"
                      />
                      <bita-spinner
                        :is-loading="isLoadingCitiesDestination"
                        class-name="col-lg-2"
                        styleName="align-self: center;"
                      />
                      <bita-select
                        v-if="this.isLoadingCitiesDestination === false"
                        name="citiesDestination"
                        label="شهر مقصد"
                        ref="citiesDestinationDropDown"
                        rules
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="citiesDestination"
                        data-text-field="name"
                        data-value-field="id"
                        @change="loadData"
                        v-model="filters.destination_city_id"
                      />
                      <bita-datepicker
                        type="date"
                        id="fromDate"
                        validation-container-class="col-lg-2"
                        name="from-date"
                        label="از تاریخ"
                        inputClass="form-control"
                        @change="loadData"
                        v-model="filters.fromDate"
                      />
                      <bita-datepicker
                        type="date"
                        id="toDate"
                        validation-container-class="col-lg-2"
                        name="to-date"
                        label="تا تاریخ"
                        inputClass="form-control"
                        @change="loadData"
                        v-model="filters.toDate"
                      />
                    </div>
                  </div>
                </bita-form>
                <div class="col-12 col-md-2">
                  <bita-filtersbutton
                    icon="fas fa-print"
                    title="چاپ"
                    @click="print"
                  />
                </div>
              </div>
            </div>
          </bita-form>
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
          />
        </div>
      </bita-ibox>
    </div>
    <checkout-modal
      modal-id="checkout-modal"
      :title="`ترخیص بار`"
      :propsData="updateForm"
      :category-loads="parentLoads"
      :customers="customers"
      :is-loading="isLoadingModal"
      @on-submit="(e) => checkout(e)"
    />
  </div>
</template>
<script>
import CheckoutModal from "./CheckoutModal";

export default {
  components: { CheckoutModal },
  data() {
    return {
      colWidth: "col-lg-2 col-md-6 col-sm-6",
      breadCrumbs: [
        { title: "صفجه اصلی", link: "/" },
        {
          title: "پذیرش بار",
          link: "/request-detail-confirmation",
          active: true,
        },
      ],
      filters: {},
      cargo: {},
      parentLoads: [],
      loads: [],
      customers: [],
      updateForm: {},
      isLoadingModal: false,
      requestDetailState: true,
      disabled: true,
      isLoadingData: false,
      filter: {},
      isLoadingCitiesOrgin: false,
      isLoadingCitiesDestination: false,
      state: {},
      citiesOrgin: {},
      citiesDestination: {},
    };
  },
  computed: {
    gridColumns() {
      return [
        // { title: "#", template: this.$getTemplate, width: "40px" },
        {
          field: "tracking_code",
          title: "کد پیگیری",
          template: (e) =>
            e.request_detail_tracking_code
              ? e.request_detail_tracking_code
              : " - ",
          width: "100px",
        },
        {
          field: "driver_name",
          title: "نام راننده",
          template: (e) =>
            e.driver_name && e.driver_family
              ? e.driver_name + " " + e.driver_family
              : " - ",
          width: "100px",
        },
        {
          field: "driver_national_code",
          title: "کد ملی راننده",
          template: (e) =>
            e.driver_national_code ? e.driver_national_code : " - ",
          width: "100px",
        },
        {
          field: "number_plate",
          title: "شماره پلاک",
          template: (e) => (e.number_plate ? e.number_plate : "-"),
          width: "100px",
        },
        {
          field: "customer_name",
          title: "مشتری",
          template: (e) =>
            e.customer_name && e.customer_family
              ? e.customer_name + " " + e.customer_family
              : " - ",
          width: "100px",
        },
        {
          field: "destination_province",
          title: "مقصد",
          template: (e) =>
            e.destination_province ? e.destination_province : " - ",
          width: "100px",
        },
        {
          field: "load_name",
          title: "نوع بار",
          template: (e) => (e.load_name ? e.load_name : " - "),
          width: "100px",
        },
        {
          field: "state_name",
          title: "وضعیت",
          template: (e) => (e.state_name ? e.state_name : " - "),
          width: "100px",
        },
        {
          field: "loading_at",
          title: "تاریخ بارگیری",
          template: (e) =>
            e.request_loading_at
              ? this.$getJalaliDateFromDateTime(e.request_loading_at)
              : " - ",
          width: "100px",
        },
        {
          title: "عملیات",
          command: this.gridCommands(),
          width: "150px",
        },
      ];
    },
  },
  mounted() {
    Promise.all([this.getLoads(0), this.getCustomers(), this.getState()]).then(
      (res) => {
        this.parentLoads = res[0].data;
        this.customers = res[1].data;
        this.state = res[2].data;
      }
    );
  },
  methods: {
    status(e) {
      let data = this.$refs.grid.getSelectedGridRow(e);

      if (data.state_id != 4) {
        this.$izitoast(
          "error",
          "ناموفق",
          "شما دسترسی به تغییر وضعیت این بار را ندارید"
        );
        return;
      }

      this.$alert(
        "question",
        `آیا از تغییر وضعیت این بار به در‌ انتظار تحویل اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingData = true;
          let status = {
            state_id: 5,
          };
          this.$persistClient(
            "patch",
            `request-details/${data.request_detail_id}/states`,
            status
          )
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingData = false;
            });
        }
      });
    },
    checkout(e) {
      this.isLoadingModal = true;
      if (e.alertCheck) {
        this.$persistClient(
          "patch",
          `request-details/${e.id}/owner-checkout`,
          e
        )
          .then((res) => {
            this.loadData();
            this.$toggleModal("#checkout-modal");
            this.$izitoast("success", "موفق", "بار شما با موفقیت ترخیص  شد.");
            this.$root.$emit("update:smscredit");
          })
          .finally(() => {
            this.isLoadingModal = false;
          });
      } else {
        this.isLoadingModal = false;
        this.$toggleModal("#checkout-modal");
      }
    },
    getLoads(categoryId) {
      return this.$persistClient(
        "get",
        `loads?filter[parentItem]=${categoryId}`
      );
    },
    getCustomers() {
      return this.$persistClient("get", "customers");
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "checkout",
        click: this.openCheckoutModal,
        template: this.gridButtons.checkout,
      });
      commands.push({
        text: "print",
        click: this.printCargo,
        template: this.gridButtons.print,
      });
      commands.push({
        text: "status",
        click: this.status,
        template: this.gridButtons.status,
      });
      return commands;
    },
    printCargo(e) {
      let requestDetail = this.$refs.grid.getSelectedGridRow(e);
      let q = { request_detail: requestDetail.request_detail_id };
      this.$print("reports/export-requestdetail", q);
    },
    openCheckoutModal(e) {
      this.$toggleModal("#checkout-modal");
      this.isLoadingModal = true;
      let checkoutable = this.$refs.grid.getSelectedGridRow(e);
      this.$persistClient(
        "get",
        `request-details/${checkoutable.request_detail_id}/checkoutable`
      )
        .then((res) => {
          if (res.data && res.data[0]) this.updateForm = res.data[0];
          else this.updateForm = {};
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    searchForDrivers: _.debounce(function(ssn) {
      if (this.$ssnIsValid(ssn)) this.loadData();
      else if (!ssn) this.loadData();
    }, 1000),
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    readData(e) {
      this.isLoadingData = true;
      var _this = this;
      var filters = {};
      if (this.filters.national_code)
        filters.national_code = this.filters.national_code;
      this.$persistClient("post", "request-details/checkoutable", this.filters)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    },
    finish(data) {
      this.$alert(
        "question",
        `بارنامه به شماره پیگیری ${data.tracking_code} از ${
          data.origin_city
        } به ${data.destination_city} توسط راننده ${
          data.driver_name ? data.driver_name : "---"
        } حرکت خواهد کرد.
آیا این اطلاعات را تایید میکنید ؟`,
        "",
        {
          confirmButtonText: "بله",
          showCancelButton: true,
        }
      ).then((res) => {
        if (res.dismiss !== "cancel") {
          this.$persistClient("patch", `cargoes/${data.id}/carried`).then(
            (res) => {
              this.$izitoast("success", "خروج موفق بار", res.data.message);
              this.searchDiver();
            }
          );
        }
      });
    },
    getState() {
      return this.$persistClient("get", "cities?filter[province]=0");
    },
    getCityOrgin(stateId) {
      this.isLoadingCitiesOrgin = true;
      this.$persistClient("get", `cities?filter[province]=${stateId}`)
        .then((res) => {
          this.citiesOrgin = res.data;
        })
        .finally(() => {
          this.isLoadingCitiesOrgin = false;
          this.loadData();
        });
    },
    getCityDestination(stateId) {
      this.isLoadingCitiesDestination = true;
      this.$persistClient("get", `cities?filter[province]=${stateId}`)
        .then((res) => {
          this.citiesDestination = res.data;
        })
        .finally(() => {
          this.isLoadingCitiesDestination = false;
          this.loadData();
        });
    },
    findTrackingCode: _.debounce(function(e) {
      this.loadData();
    }, 1000),
    findNumberPlate: _.debounce(function(e) {
      this.loadData();
    }, 1000),
    resetFilters() {
      this.$refs.customerDropDown
        ? this.$refs.customerDropDown.emptyKendo()
        : null;
      this.$refs.destinationstateDropDown
        ? this.$refs.destinationstateDropDown.emptyKendo()
        : null;
      this.$refs.citiesDestinationDropDown
        ? this.$refs.citiesDestinationDropDown.emptyKendo()
        : null;
    },
    print() {
      this.$print("reports/export-list-requestdetail", this.filters);
    },
  },
};
</script>
